import { Acceleration, Measure, meters, seconds } from 'safe-units';

export const gravity: Acceleration = Measure.of(
  9.8,
  meters.per(seconds.squared()),
);
